import { SCORE_LABELS } from '@/constants';
import { cn } from '@/utils';
import { scoreHistoryCardStyles, scoreHistoryListStyles } from '../ScoreHistoryCard.styles';
import { ScoreHistoryCardTitle } from './ScoreHistoryCardTitle';
import React from 'react';

/**
 * Props for the ScoreHistoryCardEmptyState component.
 */
interface ScoreHistoryCardEmptyStateProps {
  /** Additional CSS classes forwarded to the outer card wrapper. */
  className?: string;
  /** Card title shown above the empty state message. */
  title: string;
  /** Whether to render a border around the card. */
  withCardBorder?: boolean;
}

/**
 * Empty state for ScoreHistoryCard.
 * Rendered when the entries array is empty, showing the card shell and a descriptive message.
 */
export const ScoreHistoryCardEmptyState: React.FC<ScoreHistoryCardEmptyStateProps> = ({
  className,
  title,
  withCardBorder,
}) => (
  <div className={cn(scoreHistoryCardStyles({ bordered: withCardBorder }), className)}>
    <ScoreHistoryCardTitle title={title} />
    <div className={scoreHistoryListStyles}>
      <p role="status" className="typography-body py-4 text-neutral-gray-600">
        {SCORE_LABELS.NO_PREVIOUS_SCORES_AVAILABLE}
      </p>
    </div>
  </div>
);

ScoreHistoryCardEmptyState.displayName = 'ScoreHistoryCardEmptyState';

export default ScoreHistoryCardEmptyState;
